export default __webpack_public_path__ + "static/media/logo.102b4052.png";